module.exports = __webpack_public_path__ + "img/IND-i-1-V.7ebcd574.png";